import React, { useMemo, useEffect } from 'react';
import { Error, Loading, MediaPageView } from '../../components';
import { useSelector } from 'react-redux';
import analytic, { analyticTypes } from '../../service/analytic';

const Home = () => {
  const { data: pageData, loading, err } = useSelector((state) => state.page);
  const data = useMemo(() => {
    return pageData.find((item) => item.friendlyId === 'home');
  }, [pageData]);

  useEffect(() => {
    analytic(analyticTypes.trackPage, 'Home');
  }, []);

  return <MediaPageView data={data} loading={loading} err={err} />;
};

export default Home;
